export default __webpack_public_path__ + "static/media/deloitte-greenshield_showcase1.png";